"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var a_fetch_1 = require("a-fetch");
function Menu(_a) {
    var video = _a.video, videoLength = _a.videoLength, trimStart = _a.trimStart, trimEnd = _a.trimEnd, setVideo = _a.setVideo, setModal = _a.setModal, modalClose = _a.modalClose;
    var minTrimRange = 20; // seconds.
    var onSave = function () {
        var trimIn = normalizeTime(trimStart);
        var trimOut = normalizeTime(trimEnd);
        modalClose();
        if ((trimEnd - trimStart) < minTrimRange) {
            return alert('De video lengte is te kort! Minimaal 20 seconden.');
        }
        a_fetch_1.Fetcher.api('media').update('media.trim', {
            id: video.external_id,
            media_url: video.src.split('?')[0],
            trim_in: trimIn,
            trim_out: trimOut,
        }).then(function (response) {
            if (response.data.status === 'updating') {
                setVideo(__assign(__assign({}, video), { status: 'draft' }));
            }
        });
    };
    var cancel = function () {
        window.location.reload();
    };
    var normalizeTime = function (seconds) {
        var time = storybook_1.Helpers.toHHMMSS(seconds);
        if (time.length === 5) {
            return '00:' + time;
        }
        return time;
    };
    return react_1.default.createElement("div", { className: 'storybook-timelines-menu' },
        react_1.default.createElement("div", { className: 'storybook-pages-videosclips-time' }, videoLength && react_1.default.createElement(storybook_1.Forms.Input, { disabled: true, value: storybook_1.Helpers.toHHMMSS(videoLength), onChange: function () {
                console.log('set change');
            } })),
        react_1.default.createElement(storybook_1.Menus.Dashboard.Buttons, null,
            react_1.default.createElement(storybook_1.Buttons.Button, { type: 'default', onClick: cancel, disabled: trimStart === 0 && trimEnd === 0 }, "Inkorten annuleren"),
            react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Timelines.VideoSave, { onSave: onSave }); },
                }); }, type: 'primary', disabled: trimStart === 0 && trimEnd === 0 }, "Inkorten")));
}
exports.default = Menu;
